import { Modal } from 'react-bootstrap';
import GraphicsUserAuthorizationFailed from 'assets/images/graphics__user-authorization-failed.svg';
import { useBrowserAuth } from '../../providers/BrowserAuthProvider';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';

export default function UserAuthorizationFailedDialog({
  show,
  onClose,
  title = 'Access Denied',
  message = 'User did not authorize this request',
}) {
  const { logout } = useBrowserAuth();

  const onCloseClick = async () => {
    onClose();
    await logout();
  };
  return (
    <>
      <Modal
        show={show}
        onHide={onCloseClick}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton closeVariant="white"></Modal.Header>
        <Modal.Body className="pb-5">
          <div className="d-flex flex-column align-items-center">
            <img
              src={GraphicsUserAuthorizationFailed}
              alt=""
              className="mb-5"
            />
            <h4 className="mb-2">{title}</h4>
            <p className="m-0">{message}</p>
            <div className="d-flex gap-3 mt-4">
              <StylishNewButton
                className="button button--secondary"
                onClick={onCloseClick}
              >
                Logout
              </StylishNewButton>
              <StylishNewButton
                className="button button--primary"
                onClick={() => window.location.assign('/hub')}
              >
                Go to Hub
              </StylishNewButton>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
